import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { composeUrl } from 'app/core/shared/helper/url.helper';
import { OptionTypeService } from 'app/modules/option-type/services/option-type.service';
import { environment } from 'environments/environment';
import { BehaviorSubject, map, Observable, take, tap } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CorrectiveMaintenanceService {
    private _cmRecord: BehaviorSubject<any> = new BehaviorSubject(null);

    constructor(
        private _httpClient: HttpClient,
        private metadataServices: OptionTypeService
    ) { }

    get cmRecord$(): Observable<any> {
        return this._cmRecord.asObservable();
    }

    getCMRecords(params: any): Observable<any> {
        const url = composeUrl(
            '/v1/CorrectiveMaintenance/GetCorrectiveMaintenanceList',
            params
        );

        return this._httpClient.get<any>(url);
    }

    getCMRecord(cmId: any): Observable<any> {
        return this._httpClient.get<any>(`${environment.apiURL}/${environment.apiVersion}/CorrectiveMaintenance/GetCorrectiveMaintenanceList/${cmId}`).pipe(
            tap((response: any) => {
                this._cmRecord.next(response);
            }),
        );
    }

    updateCM(payload: any): Observable<any> {
        const url = composeUrl(`/v1/CorrectiveMaintenance/CreateUpdateCorrectiveMaintenance`);
        return this._httpClient.post<any>(url, payload).pipe(take(1));
    }

    getFailEquipmentList() {
        return this.metadataServices.getOptionItems("md_cm_equipment").pipe(
            map((res) => {
                return res.data
            })
        );
    }

    downloadCMRecords(category) {
        let params = new HttpParams()
            .set('category', category)

        return this._httpClient.get(`${environment.apiURL}/${environment.apiVersion}/CorrectiveMaintenance/DownloadOverallCmExcel`, {
            params: params,
            responseType: 'blob',
        }).pipe(
            tap((response: any) => {
                return response
            }),
        );
    }
}
